var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tw-tickets tw-stage tw-stage--padded"},[_c('div',{staticClass:"tw-items tw-responsive__xs--half-padding tw-responsive__xxs--half-padding"},[_c('div',{staticClass:"tw-item tw-item--muted"},[_c('p',{staticClass:"tw-text--center"},[_vm._v(_vm._s(_vm.errorMessage))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }